import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-whatsapp-messages',
  templateUrl: './whatsapp-messages.component.html',
  styleUrls: ['./whatsapp-messages.component.css']
})
export class WhatsappMessagesComponent implements OnInit {

  constructor(private service: UserService) {
    this.service.getWhatsappMessages(0,this.filtro).subscribe(d=>{
      this.messages = d.messages;
    });

    this.service.getWhatsappQueued().subscribe(d=>{
      this.encolados = d.tickets;
      this.calculateTimes();
    })
   }

  messages = [];
  encolados = [];
  page = 0;

  filtro = "";
  filtrar(){
    console.log("Filtrar por: " + this.filtro);
    this.service.getWhatsappMessages(0,this.filtro).subscribe(d=>{
      this.messages = d.messages;
    })
    
  }

  ngOnInit() {
    setInterval(()=> this.calculateTimes(), 20000);
  }

  calculateTimes(){
    this.encolados.forEach(x=>{
      x.finalizado = new Date(x.finalizado_timestamp);
      x.remaining = this.getTime(x.finalizado_timestamp);
    })
  }

  nextPage(){
    this.page++;
    this.service.getWhatsappMessages(this.page,this.filtro).subscribe(d=>{
      for(let m of d.messages){
        this.messages.push(m);
      }
      if(d.messages.length==0){
        this.page=-1;
        alert("No hay más mensajes");
      } 
    });
  }

  getTime(from_timestamp){
    let today = new Date(new Date().getTime() - (1000*60*60*48));
    let from = new Date(from_timestamp);;
    let diffMs = from.getTime() - today.getTime(); // milliseconds between now & Christmas
    var diffDays = Math.floor(diffMs / 86400000); // days
    var diffHrs = Math.floor( (diffMs % 86400000) / 3600000 ); // hours
    let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
    
    return Math.max(0,diffDays) + "D " + Math.max(0,diffHrs)   + "H " + Math.max(0,diffMins) +"M";
  }

  toggleWhatsapp(t){
    if(confirm(t.send_whatsapp?"Desactivar whatsapp?":"Activar whatsapp?")){
      this.service.toggle_ticket_whatsapp(t._id, !t.send_whatsapp).subscribe(d=>{
        t.send_whatsapp = !t.send_whatsapp;
      })
    }
  }
}
